class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });

  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    
    window.addEventListener("extendSoftRefresh", this._extendSoftRefresh.bind(this));

  }

  _extendSoftRefresh(updates) {
    this.updateQuantity(updates.detail.line, updates.detail.quantity)
  }

  getCurrentItemHandles(){
    var itemsInCartLinks = [...this.querySelectorAll(".cart-item__details a")];
    return itemsInCartLinks.map((itemATag)=>{
      return itemATag.href.split("/")[itemATag.href.split("/").length - 1];
    });
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
  
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      }).then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
        if (window.cartNotificationMode == "drawer_mode" && parsedState.item_count === 0){
          document.querySelector('cart-drawer').updateEmptyCartDrawer();
        }
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.disableLoading();
      }).then(() => {
        // Extend - Dispatch event
        setTimeout(() => {
            window.dispatchEvent(new Event('refreshAjaxCart'))
            setTimeout(() => {
                checkSpecialVariants();
            }, 500);

        }, 1000);
        // Extend - End code
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      }).finally(()=>{
        [...document.querySelectorAll('upsell-element')].forEach((upsellElement)=>upsellElement.updateUpsells())
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

let dialogShown = false;
let selectedPlanGroup = null;

async function checkSpecialVariants() {
  if (dialogShown) return;

  const requiredVariantIds = ["41259099717684", "41259100340276"];
  const cartItems = document.querySelectorAll(".cart-item");

  let cartProducts = [...cartItems].map(item => {
  const priceText = item.querySelector('.price')?.textContent || "0";
  const price = parseInt(priceText.replace(/\D/g, "")); 
  const quantity = parseInt(item.querySelector('.quantity__input')?.value || 1);
  const title = item.querySelector('.cart-item__name')?.textContent.trim() 
             || item.querySelector('.cart-item__details a')?.textContent.trim()
             || "Unknown Product";

  return {
    referenceId: item.dataset.variantId,
    quantity: quantity,
    category: item.dataset.category,
    price: price,
    title: title 
  };
});

// Only keep products matching requiredVariantIds
cartProducts = cartProducts.filter(p => requiredVariantIds.includes(p.referenceId));

  const cartVariantIds = cartProducts.map(p => p.referenceId);
  const allPresent = requiredVariantIds.every(id => cartVariantIds.includes(id));
  if (!allPresent) return;

  // Check if Extend plans already exist in cart
  const cartRes = await fetch("/cart.js");
  const cartData = await cartRes.json();
  const hasExtendPlans = cartData.items.some(item => 
    item.properties && item.properties["__Extend.IsExtendWarranty"]
  );

  if (hasExtendPlans) {
    console.log("Extend plan already exists, skipping modal.");
    return;
  }

  const dialog = document.getElementById("special-variant-dialog");
  const offerContainer = document.getElementById("extend-offer-container");
  offerContainer.innerHTML = "<p>Loading offers...</p>";

  await waitForExtend();

  try {
    // Fetch offers individually
    const offersByProduct = [];
    for (let product of cartProducts) {
      const offers = await Extend.getOffer({ 
        products: [{ ...product, quantity: 1 }] 
      });
      offersByProduct.push(offers);
    }

    // Merge plans by term length
    const mergedPlans = {};
    offersByProduct.forEach((offers, idx) => {
      const recommendedKey = offers?.plans?.recommended;
      const plans = recommendedKey ? offers.plans[recommendedKey] : [];
     plans.forEach(plan => {
        const term = plan.contract.termLength; // e.g. 12, 24, 36
        if (!mergedPlans[term]) mergedPlans[term] = { totalPrice: 0, plans: [] };

        const product = cartProducts[idx]; 
        mergedPlans[term].totalPrice += plan.price * product.quantity; // total price reflects cart qty
        mergedPlans[term].plans.push({ ...plan, productIndex: idx });
      });
    });

    const combinedPlans = Object.values(mergedPlans);

    // If no offers, skip modal entirely
    if (combinedPlans.length === 0) {
      console.log("No Extend offers available, skipping modal.");
      return;
    }

    // Only open modal if there ARE offers
    if (dialog && !dialog.open) {
      dialog.showModal();
      dialogShown = true;
    }

    // Render combined offers
    offerContainer.innerHTML = `
      <div class="offers-container-buttons">
        <div class="button-group">
  ${combinedPlans.map((cp, idx) => {
    const years = cp.plans[0].contract.termLength / 12;
    const label = years === 3 ? "Best Value" : years === 2 ? "Best Seller" : "";
    const isActive = idx === 1;

    return `
      <button class="button btn-offer ${isActive ? 'active' : ''}" 
              type="button" 
              data-term="${cp.plans[0].contract.termLength}"
              data-plan-index="${idx}"> 
        ${label ? `
          <svg class="banner-svg" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <filter x="-9.9%" y="-6.7%" width="116.5%" height="116.8%" filterUnits="objectBoundingBox" id="a">
                <feOffset dx="-1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.324 0" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
              <path id="b" d="M0 4.468h25.582l35.006 33.788v25.678z"></path>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(4 -2)">
                <use class="svg-bg" filter="url(#a)" xlink:href="#b"></use>
                <use class="svg-bg" xlink:href="#b"></use>
              </g>
              <text class="svg-text" transform="rotate(45 40.459 32.434)" letter-spacing="-.255">
                <tspan x="12.006" y="31.606">${label}</tspan>
              </text>
            </g>
          </svg>
        ` : ''}
        <div class="btn-content">
          <span class="term-length">${years} ${years === 1 ? "Year" : "Years"}</span>
          <span class="divider">Protection</span>
          <span class="plan-price">$${(cp.totalPrice / 100).toFixed(2)}</span>
        </div>
      </button>
    `;
  }).join("")}
</div>


        <div class="buttons-container">
          <button class="button-link" type="button" name="decline">
            I don't want protection
          </button>
          <button class="button-submit" type="submit">
            Protect my purchase
          </button>
        </div>
      </div>
    `;

    // Set default selection (index 1 if exists, otherwise 0)
    selectedPlanGroup = combinedPlans[1] || combinedPlans[0];

    // Plan button click handlers
    const planButtons = offerContainer.querySelectorAll(".btn-offer");
    planButtons.forEach((button, buttonIndex) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        planButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        selectedPlanGroup = combinedPlans[buttonIndex];
      });
    });

    // Submit button handler
    const submitButton = offerContainer.querySelector('.button-submit');
    submitButton.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!selectedPlanGroup) {
        alert('Please select a protection plan first.');
        return;
      }

      submitButton.disabled = true;
      submitButton.innerHTML = `Adding protection...`;

      try {
        for (let plan of selectedPlanGroup.plans) {
          const product = cartProducts[plan.productIndex];
          await addExtendPlanVariantToCart({ plan, product });
        }
        window.location.reload();
      } catch (err) {
        console.error("Error adding Extend combo plans:", err);
        submitButton.disabled = false;
        submitButton.innerHTML = "Protect my purchase";
        alert("Something went wrong while adding your protection plan. Please try again.");
      }
    });

    // Decline button handler
    const declineButton = offerContainer.querySelector('.button-link');
    declineButton.addEventListener('click', (e) => {
      e.preventDefault();
      dialog.close();
      dialogShown = false;
    });

    // Store references globally
    window.combinedPlans = combinedPlans;
    window.cartProducts = cartProducts;

  } catch (err) {
    console.error("Error while fetching Extend offers:", err);
    // Don't open modal if Extend API fails
    return;
  }
}

async function waitForExtend() {
    return new Promise((resolve, reject) => {
        let tries = 0;
        const maxTries = 50;
        const interval = setInterval(() => {
            if (window.Extend && typeof Extend.getOffer === "function") {
                clearInterval(interval);
                resolve();
            } else if (tries++ > maxTries) {
                clearInterval(interval);
                reject(new Error("Extend did not load in time"));
            }
        }, 100);
    });
}

// Add plan variant to cart for a specific product
function addExtendPlanVariantToCart({ plan, product }) {
    return new Promise((resolve, reject) => {
        const planPriceInCents = Math.round(plan.price);

        ExtendShopify.getPlanVariant({ premium: planPriceInCents }, async function (err, planVariant) {
            if (err || !planVariant?.variantId) {
                console.error("Error getting Extend plan variant:", err);
                reject(err);
                return;
            }

            const bundleId = `id-${Date.now()}-${product.referenceId}`;

            try {
                const addResponse = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    body: JSON.stringify({
                        items: [{
                            id: planVariant.variantId,
                            quantity: product.quantity,
                            properties: {
                                "__Extend.IsExtendWarranty": true,
                                "__Extend.OfferPlanId": plan.offerPlanId,
                                "_Extend.IsPricePoint": true,
                                "_Extend.PlanId": plan.id,
                                "_Extend.ProductId": product.referenceId,
                                "Product": product.title,
                                "Term": `${plan.contract.termLength / 12} ${plan.contract.termLength / 12 === 1 ? 'year' : 'years'}`,
                                "__Extend.BundleId": bundleId,
                                "__Extend.IsBundle": true
                            }
                        }]
                    })
                });

                const added = await addResponse.json();
                resolve(added);
            } catch (err) {
                reject(err);
            }
        });
    });
}

customElements.define('cart-items', CartItems);

document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname === "/cart") {
    checkSpecialVariants();
    }
});

// Ensure only one plan can be selected
document.querySelectorAll('#special-variant-dialog .btn-offer').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelectorAll('#special-variant-dialog .btn-offer').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
    });
});